import axios from "@/plugins/axios";

// Pendapatan Isi Rumah Bulanan Penengah (median) — pulls aggregated median
// income from the per-survey-year summary tables (ClickHouse
// `lampiran_hid_summary_<YEAR>`). Year columns are discovered server-side from
// the table list and returned in `data.years`; each row carries a per-year
// `values` map. W = "W" (weighted) | "TW" (unweighted) selects the median type.
export default class pendapatanPenengahServices {
  // params: { NG?, DP?, P (csv pusingan), S ("1"|"2"|"3"), W ("W"|"TW") }
  async getPendapatanPenengah(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getPendapatanPenengahLampiran`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
